import { Slide } from "@jelly/lesson";

import { task as task02 } from "../../../../../task/course-04/lesson-19/task-02";

const task: Slide = {
  titleHtml:
    "A loudspeaker has a compliance of 1.3 mm/N and a surface of 53 cm<sup>2</sup>, choose the</br>value of its equivalent volume V<sub>as</sub> from the proposals below.",
  description: "Select the correct answer.",
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "__task__",
        data: {
          id: task02.id,
        },
      },
    },
  },
};

export default task;
